import { routes, afterRoutes } from '@/router'

const router = {
  state: {
    navRouters: [],
  },
  mutations: {
    SET_NAV_ROUTERS: (state, dynamicRoutes) => {
      const after = afterRoutes.map(item => {
        return {
          ...item,
          path: item.path.includes('document') ? '/document' : item.path
        }
      })
      state.navRouters = [...routes, ...dynamicRoutes, ...after]
    },
  },
  actions: {
    setNavRouters({ commit }, routes) {
      commit('SET_NAV_ROUTERS', routes)
    },
  }
}

export default router
